import { VideoOptions } from '../utilities/video';

export default class YoutubeVideo {
    options: VideoOptions;
    player: any;
    videoInterval: any;

    constructor(options: VideoOptions) {
        this.options = options;
        this.init();
    }

    private initPlayer() {
        (window as any).youtubeIsReady = true;
        if (this.videoInterval) clearInterval(this.videoInterval);

        const playerOptions: { [key: string]: any } = {
            host: 'https://www.youtube-nocookie.com',
            playerVars: {
                start: this.options.videoTime,
                modestbranding: 1,
                showinfo: 0,
                controls: this.options.videoControls,
                rel: 0,
                origin: window.location.href,
                loop: this.options.videoLoop,
                autoplay: this.options.videoAutoplay,
                playsinline: this.options.videoPlaysinline,
                mute: this.options.videoMuted,
            },
            events: {
                onReady: this.onReadyEvent.bind(this),
                onStateChange: this.onStateChange.bind(this),
            },
        };

        if (this.options.isPlaylist) {
            playerOptions.playerVars.listType = 'playlist';
            playerOptions.playerVars.list = this.options.videoId;
        } else {
            playerOptions.videoId = this.options.videoId;
        }

        if ((window as any).YT && (window as any).YT.Player) {
            this.player = new (window as any).YT.Player(this.options.player, playerOptions);
        }
    }

    static loadAPI() {
        // This code loads the IFrame Player API code asynchronously.
        const tag = document.createElement('script');
        tag.src = 'https://www.youtube.com/iframe_api';
        const firstScriptTag = document.getElementsByTagName('script')[0];

        if (firstScriptTag.parentNode) {
            firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);
        }
    }

    private init() {
        if (!(window as any).YT) {
            YoutubeVideo.loadAPI();
            this.checkAPIReady();
            return;
        }

        this.checkAPIReady();
    }

    private checkAPIReady() {
        (window as any).onYouTubeIframeAPIReady = () => this.initPlayer();

        this.videoInterval = setInterval(() => {
            if (window as any) {
                this.initPlayer();
                this.videoInterval && clearInterval(this.videoInterval);
            }
        }, 200);
    }

    private onReadyEvent() {
        this.options.element.ready();
    }

    private onStateChange(event: { data: number }) {
        switch (event.data) {
            // finished
            case 0:
                this.options.element.ended();
                break;

            // playing
            case 1:
                this.options.element.playing();
                break;

            // paused
            case 2:
                this.options.element.paused();
                break;

            // do nothing
            default:
                break;
        }
    }

    play() {
        this.player.playVideo();
    }

    pause() {
        this.player.pauseVideo();
    }

    replay() {
        this.player.stopVideo();
        this.player.playVideo();
    }

    mute() {
        this.player.mute();
    }

    unMute() {
        this.player.unMute();
    }

    setVolume(value: number) {
        this.player.setVolume(value);
    }
}
